import { render } from "./MiniAppSettings.vue?vue&type=template&id=733b91a2&scoped=true&ts=true"
import script from "./MiniAppSettings.vue?vue&type=script&lang=ts"
export * from "./MiniAppSettings.vue?vue&type=script&lang=ts"

import "./MiniAppSettings.vue?vue&type=style&index=0&id=733b91a2&lang=scss&scoped=true"

import exportComponent from "/Users/kameyamanaoki/dev/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-733b91a2"]])

export default __exports__